import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  handleAPIErrorToast,
  loadingToast,
  successToast,
} from "@/component/toasts";
import {
  createStaffAsync,
  deleteStaffAsync,
  getStaffAsync,
  updateStaffAsync,
} from "@/services/staff";

export const getStaffUsersAsync = createAsyncThunk(
  "staff/getStaffUsers",
  async (payload: {
    page: number;
    query: string;
    limit: number | string;
    sort?: {
      order: "asc" | "desc";
      key: string;
    };
    jobRoles?: any;
    status?: any;
    includeMe?: boolean;
  }) => {
    try {
      const response = await getStaffAsync(payload);
      return response.data;
    } catch (error: any) {
      handleAPIErrorToast(error);
      throw new Error("Failed to fetch data");
    }
  }
);

export const getStaffUsersBySearchAsync = createAsyncThunk(
  "staff/getStaffUsersBySearch",
  async (payload: {
    page: number;
    query: string;
    limit: number | string;
    sort?: {
      order: "asc" | "desc";
      key: string;
    };
    jobRoles?: any;
    status?: any;
    includeMe?: boolean;
  }) => {
    try {
      const response = await getStaffAsync(payload);
      return response.data;
    } catch (error: any) {
      handleAPIErrorToast(error);
      throw new Error("Failed to fetch data");
    }
  }
);

export const createStaffUserAsync = createAsyncThunk(
  "staff/createStaffUser",
  async (data: any) => {
    let response;
    try {
      response = await createStaffAsync(data);
      successToast("Staff created successfully");
      return response.data;
    } catch (error: any) {
      handleAPIErrorToast(error);
      throw new Error("Failed to fetch data");
    }
  }
);

export const updateStaffUserAsync = createAsyncThunk(
  "staff/updateStaffUser",
  async ({ id, data }: any, { rejectWithValue }) => {
    let response;
    try {
      response = await updateStaffAsync(id, data);

      return {
        ...response.data,
        data: {
          id: response.data.data._id,
          _id: response.data.data._id,
          name: response.data.data.name,
          avatar: response.data.data.avatar,
          firstName: response.data.data.firstName,
          middleName: response.data.data.middleName,
          lastName: response.data.data.lastName,
          jobRoles: response.data.data.jobRoles,
          status: response.data.data.status,
        },
      };
    } catch (error: any) {
      throw rejectWithValue(error);
    }
  }
);

export const deleteStaffUserAsync = createAsyncThunk(
  "staff/deleteStaffUser",
  async (id: string) => {
    let response;
    loadingToast("Deleting Staff...");
    try {
      response = await deleteStaffAsync(id);
      successToast("Staff deleted successfully");
      return response.data;
    } catch (error: any) {
      handleAPIErrorToast(error);
      throw new Error("Failed to fetch data");
    }
  }
);
